function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Avatar from 'components/Avatar';
import Information from 'modules/Information';
var _React_PureComponent;
class UserBox extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { firstName, lastName, email, avatar } = this.props.information || {};
        return /*#__PURE__*/ _jsxs("div", {
            className: "row align-items-center mt-7",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-3",
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: avatar,
                        name: [
                            firstName,
                            lastName
                        ],
                        isRound: true
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col pl-3",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: "text--h3 text--light mb-2",
                            children: [
                                firstName,
                                " ",
                                lastName
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text--small text--disabled",
                            children: email
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(UserBox, "propTypes", {
    information: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        email: PropTypes.string.isRequired,
        avatar: PropTypes.string
    })
});
const mapStateToProps = (state)=>({
        information: Information.selectors.information(state)
    });
const ConnectedUserBox = connect(mapStateToProps)(UserBox);
export default ConnectedUserBox;
